import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { createTextElementButton_CreateTextElementMutation } from "@relay/createTextElementButton_CreateTextElementMutation.graphql";
import { CREATE_TEXT_ELEMENT_MUTATION } from "./create-text-element-button.graphql";
import { type CreateTextElementButtonProps } from "./create-text-element-button.types";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

export const CreateTextElementButton = ({
	eLearningContentNodeId,
}: CreateTextElementButtonProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [createTextElement, isCreatingTextElement] =
		useMutation<createTextElementButton_CreateTextElementMutation>(
			CREATE_TEXT_ELEMENT_MUTATION,
		);

	return (
		<Button
			disabled={isCreatingTextElement}
			tooltip={t("educationalOffer.createTextElementTooltip")}
			icon={EpicIcons.LIST}
			onClick={() => {
				createTextElement({
					variables: {
						input: {
							title: t("educationalOffer.newTextElement"),
							text: t("educationalOffer.newText"),
							eLearningContentNodeId: eLearningContentNodeId,
						},
					},
					updater: setDraft,
				});
			}}
		/>
	);
};
